<template>
    <!-- <el-container class="element-sideEditor"> -->
            <!--  -->
            <div class="operate-search" :key="timer">
                <!-- <el-collapse v-model="activeName" @change="handleChange">
                    <el-collapse-item -->
                    <div class="operate-search-item"
                        v-for="(conditionField, index) in conditionFields"
                        :key="conditionField.id"
                        :name="index">
                        <div class="search-title">
                            {{conditionField.name}}
                        </div>
                        <el-form size="mini" label-width="80px" class="button-props">
                            <el-form-item label="条件">
                              <el-select v-model="conditionField.operateType" placeholder="请选择">
                                  <el-option label="包含" :value='1'></el-option>
                                  <el-option label="等于" :value='2'></el-option>
                                  <el-option label="不等于" :value='3'></el-option>
                                  <template v-if="conditionField.type === 'date'">
                                      <el-option label="范围" :value='6'></el-option>
                                  </template>
                                  <template v-else>
                                      <el-option label="大于等于" :value='4'></el-option>
                                      <el-option label="小于等于" :value='5'></el-option>
                                  </template>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="内容">
                                <template v-if="conditionField.type === 'date'">
                                        <template v-if="conditionField.operateType === 6">
                                        <el-date-picker type="date" v-model="conditionField.conditionValueSdt" value-format="yyyy-MM-dd" :editable="true" placeholder="开始时间"></el-date-picker>
                                        <el-date-picker type="date" v-model="conditionField.conditionValueEdt" value-format="yyyy-MM-dd" :editable="true" placeholder="结束时间"></el-date-picker>
                                    </template>
                                    <template v-else>
                                            <el-date-picker type="date" v-model="conditionField.conditionValue" value-format="yyyy-MM-dd" :editable="true" placeholder="选择日期"></el-date-picker>
                                    </template>
                                </template>
                                <template v-else>
                                    <SearchConditionFieldItem  :key="conditionField.id" :field="conditionField" :formData="formData" />
                                </template>
                            </el-form-item>
                            <el-form-item v-if="conditionField.type === 'text' || conditionField.type === 'date' || conditionField.type === 'calculation' || conditionField.type === 'subFormSummary' || conditionField.type === 'serialNumber' || conditionField.type === 'number'" label="排序">
                                <el-select clearable v-model="conditionField.orderByRule"  placeholder="请选择">
                                    <el-option label="不排序" value=''></el-option>
                                    <el-option label="升序" value='ASC'></el-option>
                                    <el-option label="降序" value='DESC'></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!-- <div class="search-opt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="searchForList">查询</el-button>
                        <el-button icon="el-icon-refresh" @click="resetSearchConditon">重置</el-button>
                    </div> -->
                    <!-- </el-collapse-item>
                </el-collapse> -->
            </div>
    <!-- </el-container> -->
</template>
<script>
    import SearchConditionFieldItem from './SearchConditionFieldItem';
    export default {
        components: {
            SearchConditionFieldItem
        },
        data () {
            return {
                activeName: [],
                formData: {},
                timer: ''
            };
        },
        props: {
            conditionFields: {
                type: Array
            },
            fullScreen: {
                type: Boolean,
                default: false
            }
        },
        created () {
            this.activeName = [];
            for (let i = 0; i < this.conditionFields.length; i++) {
                this.activeName.push(i);
            }
        },
        methods: {
            getConditionOpts (type) {
                let options = [{
                    value: 1,
                    label: '包含'
                }, {
                    value: 2,
                    label: '等于'
                }, {
                    value: 3,
                    label: '不等于'
                }];
                if (type === 'date') {
                    options.push({
                        value: 6,
                        label: '范围'
                    });
                }
                return options;
            },
            handleDeleteItem (index) {
                this.conditionFields.splice(index, 1);
            },
            getSearchCondition () {
                return this.conditionFields;
            },
            handleChange (val) {
                // console.log(val);
            },
            searchForList () {
                this.$emit('searchForList', this.conditionFields);
            },
            resetSearchConditon () {
                this.$emit('resetSearchConditon', true);
                // this.timer = new Date().getTime();
            }
        }
    };
</script>


<style lang="less">
    .operate-search {
        display: flex;
        display: flex;
        justify-content: flex-start;   /* 左对齐 */
        flex-wrap: wrap;   /* 换行 */
        width: 100%;
        .operate-search-item{
            width:22%;
            border: 1px solid #ebeef5;
            margin-left: 20px;
            margin-top: 10px;
            .render-form-item,.el-select{
                width: 100%;
                .el-date-editor,.el-input{
                    position: relative;
                    width: 82% !important;
                }
            }
        }
        .search-opt-btns{
            margin-left:10px;
            margin-top:50px;
        }
        .search-title {
           padding: 8px;
           border-left: 4px solid #409eff;
        }
        .button-props {
            margin-right: 10px;
        }
    }   
</style>



// WEBPACK FOOTER //
// src/components/SearchCondition/SearchConditionCommonField.vue